import { ticketColorOf } from '~/utils/ticketColors';

/**
 * "Kleur per ticketsoort" (organizations.shop_settings.ticket_colors, default on). TicketMark reads `enabled` itself,
 * so every mark follows; anything else that paints a ticket type's colour (a bar) goes through `colorOf`.
 * `inUse`: colours are on and at least one ticket of the current activity has one. Only then does a ticket without
 * a colour get the neutral mark (so names align); otherwise TicketMark leaves it out, since a row of grey marks says nothing.
 */
export function useTicketColors() {
  const userStore = useUserStore();
  const eventStore = useEventStore();
  const enabled = computed(() => (userStore.organization?.shop_settings as { ticket_colors?: unknown } | null)?.ticket_colors !== false);
  const inUse = computed(() => enabled.value
    && (eventStore.current_event?.ticket_types ?? []).some((tt) => (tt.kind ?? 'ticket') === 'ticket' && !!ticketColorOf(tt)));
  const colorOf = (tt: { settings?: unknown } | null | undefined) => (enabled.value ? ticketColorOf(tt) : undefined);
  return { enabled, inUse, colorOf };
}
